"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const s = ({
  title: r,
  titleId: i,
  desc: n,
  descId: o,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...t,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      r ? /* @__PURE__ */ e("title", { id: i, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m14 17-5-5 5-5"
        }
      )
    ]
  }
);
export {
  s as default
};
//# sourceMappingURL=ChevronLeftIcon.js.map
